(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["vm-sleepwear-media"] && !Shopify.designMode) return;
  try {
    
  function initSleepwearVideos() {
    const videos = document.querySelectorAll('.vm-sleepwear-videos video:not([data-vm-initialized])');
    const observer = new IntersectionObserver(entries => {
      for (const entry of entries) {
        const video = entry.target;
        if (entry.isIntersecting) {
          if (!video.src && video.dataset.src) { video.src = video.dataset.src; video.load(); }
          video.muted = true;
          if (!window.matchMedia('(prefers-reduced-motion: reduce)').matches) video.play().catch(() => {});
        } else video.pause();
      }
    }, { rootMargin: '100px', threshold: 0.05 });
    videos.forEach(video => {
      video.dataset.vmInitialized = 'true';
      video.controls = false;
      video.addEventListener('click', () => { if (video.paused) video.play().catch(() => {}); else video.pause(); });
      if (!video.poster) video.poster = video.closest('[data-vm-poster]').dataset.vmPoster;
      observer.observe(video);
    });
  }
  initSleepwearVideos();
  document.addEventListener('shopify:section:load', initSleepwearVideos);

  } catch(e) { console.error(e); }
})();
})();
